<unity-page-container [contentHeader]="$contentHeader()" [contentHeaderSecondary]="$contentHeaderSecondary()" [isLoading]="false">
  <ng-container page-return>
    <unity-action-shared [action]="$returnToAgreementAction()" />
  </ng-container>

  @let formSchema = $formSchema();
  @let initialTransitions = $initialTransitions();
  @let surveyModel = $surveyModel();

  @if (formSchema && surveyModel) {
    <unity-card-new-survey-shared
      [surveyModel]="surveyModel"
      [transitions]="initialTransitions"
      [isCreating]="$isCreating()"
      (createEvent)="onCreate($event)"
      (cancelEvent)="onCancel()" />
  }
</unity-page-container>
